// extracted by mini-css-extract-plugin
export default {"def":"_type_def__up4Zl"};